var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"12"}},[_c('label',{attrs:{"for":""}},[_vm._v("Folder Name")]),_c('v-text-field',{attrs:{"outlined":"","error-messages":_vm.itemTitleError},model:{value:(_vm.itemTitle),callback:function ($$v) {_vm.itemTitle=$$v},expression:"itemTitle"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }